import React, { useEffect, useRef, useState } from "react";
import Seo from "../components/Seo";

const reportAccessKey = (process.env.REACT_APP_WEB3FORMS_REPORT_ACCESS_KEY || "").trim();

const ReportIssue = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [issue, setIssue] = useState("");
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);
  const issueRef = useRef(null);

  useEffect(() => {
    const el = issueRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, 320)}px`;
  }, [issue]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reportAccessKey) {
      setStatus("Report form is not configured. Set REACT_APP_WEB3FORMS_REPORT_ACCESS_KEY in .env");
      return;
    }
    setSending(true);
    setStatus(null);

    const formData = new FormData();
    formData.append("access_key", reportAccessKey);
    formData.append("name", name.trim() || "Guest");
    formData.append("email", email.trim());
    formData.append("message", issue.trim());
    formData.append("subject", `Issue report from ${name.trim() || "Guest"}`);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });
      const data = await response.json();

      if (data.success) {
        setStatus("success");
        setName("");
        setEmail("");
        setIssue("");
      } else {
        setStatus(data.message || "Send failed. Please try again.");
      }
    } catch (err) {
      setStatus(err.message || "Network error. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="page legal-page">
      <Seo
        title="Report Issue"
        description="Report bugs or game issues on OctoGames and help us improve platform stability."
        path="/support/report-issue"
        keywords="report issue, octogames bug report, game bug support"
      />
      <div className="container legal-container">
        <section className="support-layout">
          <article className="legal-card support-form-card">
            <h1 className="legal-title">Report Issue</h1>
            <p className="legal-intro">
              Submit a structured bug report so we can triage and resolve issues quickly.
            </p>
            <form className="legal-form" onSubmit={handleSubmit}>
              <label className="legal-label">
                Name
                <input
                  type="text"
                  className="legal-input"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </label>
              <label className="legal-label">
                Email
                <input
                  type="email"
                  className="legal-input"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </label>
              <label className="legal-label">
                Issue
                <textarea
                  ref={issueRef}
                  className="legal-input legal-textarea"
                  placeholder="Describe the issue"
                  value={issue}
                  onChange={(e) => setIssue(e.target.value)}
                  rows={3}
                  required
                />
              </label>
              {status === "success" && (
                <p className="legal-form-success">Report sent. We&apos;ll look into it.</p>
              )}
              {status && status !== "success" && (
                <p className="legal-form-error">{status}</p>
              )}
              <button type="submit" className="legal-send-btn" disabled={sending}>
                {sending ? "Sending…" : "Submit"}
              </button>
            </form>
          </article>

          <article className="legal-card support-info-card">
            <h2 className="legal-section-title">Issue categories</h2>
            <ul className="legal-list">
              <li>Game does not load, freezes, or crashes.</li>
              <li>Broken links, missing assets, or UI layout problems.</li>
              <li>Account/favorites behavior not working as expected.</li>
            </ul>

            <h2 className="legal-section-title">Bug triage SLA</h2>
            <ul className="legal-list">
              <li>Triage acknowledgment: within 24 hours on business days.</li>
              <li>Critical issues: prioritized immediately after triage.</li>
              <li>Non-critical issues: scheduled in upcoming maintenance cycle.</li>
            </ul>

            <h2 className="legal-section-title">Required details</h2>
            <ul className="legal-list">
              <li>Exact game/page URL where the issue occurs.</li>
              <li>What you expected vs what actually happened.</li>
              <li>Browser version, device, and approximate time of issue.</li>
            </ul>

            <p className="legal-note">
              For urgent blockers, add "URGENT" in your message and include screenshots if
              possible.
            </p>
          </article>
        </section>
      </div>
    </main>
  );
};

export default ReportIssue;
